import ConfirmButton from "../../../../common/components/ConfirmButton";
import { CircularProgress } from "@material-ui/core";
import impersonateService from "../../../../services/impersonation/services";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../../shared/ClaimLists/Claim.Aml.All.List";

const Impersonate = ({
  currentUser,
  impersonate,
  getTokenForImpersonate,
  savelend,
}) => {
  return (
    <div>
      <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
        <ConfirmButton
          label="Impersonate"
          showContentAfterAction
          action={() => {
            if (savelend) getTokenForImpersonate(currentUser.Id, savelend);
            else getTokenForImpersonate(currentUser.Id, savelend);
          }}
        >
          {impersonate.fetched ? (
            <span>
              user Token: {impersonate.token}
              <br />
              {savelend ? (
                <a
                  href={
                    reloansysConfig.urls.savelend +
                    "/v1-impersonate/" +
                    impersonate.token
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  link to savelend
                </a>
              ) : (
                <a
                  href={
                    reloansysConfig.urls.loanstep +
                    "/token/" +
                    impersonate.token
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  link to loanstep
                </a>
              )}
              <br />
              <small>
                the token lasts for about 60 sec, if you dont use it by then
                reload the page and generate a new one.
              </small>
            </span>
          ) : undefined}
          {impersonate.fetching ? <CircularProgress /> : undefined}
        </ConfirmButton>
      </ClaimsWrapper>
    </div>
  );
};

export default impersonateService(Impersonate);
